import { errorToast } from "@/v2-ui/toast"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import { useUserLoginRevokeMutation } from "@/v2-backoffice-client/userLogin/revoke/userLogin.revoke.mutation"
import type { UserLoginRow } from "@/v2-backoffice-client/userLogin/list/userLogin.list.query"

export type UserLoginRevokeActionProps = {
  selectedRows: UserLoginRow[]
  onComplete?(): void
}

// Bulk-revoke action for the active-logins table's selection toolbar. Only
// live rows can be revoked, so a selection of already-revoked rows disables the
// button; mixed selections revoke just the live ones. On success the affected
// devices are booted off the data plane on their next request.
function UserLoginRevokeAction(props: UserLoginRevokeActionProps) {
  const { selectedRows, onComplete } = props

  const [revoke, { loading, error }] = useUserLoginRevokeMutation()
  errorToast(error, { title: "Failed to revoke logins" })

  const liveLoginIds = selectedRows
    .filter((row) => row.IsLive)
    .map((row) => row.LoginId)

  return (
    <ConfirmButton
      variant="warning"
      isStacked
      iconSrc="sign-out-alt"
      disabled={liveLoginIds.length === 0}
      content="Revoke the selected logins. Each device is signed out on its next request."
      confirmContent={`Revoke ${liveLoginIds.length} login${
        liveLoginIds.length === 1 ? "" : "s"
      }? The affected devices are signed out immediately.`}
      confirmVariant="warning"
      isLoading={loading}
      onConfirm={async () => {
        await revoke({ variables: { loginIds: liveLoginIds } }).catch(() => {})
        onComplete?.()
      }}
    >
      Revoke
    </ConfirmButton>
  )
}

export default UserLoginRevokeAction
